/**
 * i18n framework bootstrap for the real app. English-only for now (Settings >
 * Appearance > Language has a single option) — this wires up the machinery
 * so a future language is purely a new locale folder + one new setting
 * option, no code changes. Imported once, as a side effect, at the top of
 * index.tsx (same boot-time spot as settings/theme.ts) — never import this
 * from foundational modules like editor/schema.ts or editor/convert.ts,
 * which must stay free of any settings/registry dependency, and never from
 * tests (see setupTests.ts, which uses ./init directly instead).
 */
import { initI18n } from "./init";
import { useSettingsStore, getSettingValue } from "../settings/settingsStore";

const i18n = initI18n();

function applyLanguage(): void {
  const lang = getSettingValue("appearance", "language");
  const value = typeof lang === "string" && lang ? lang : "en";
  if (i18n.language !== value) void i18n.changeLanguage(value);
}

applyLanguage();
useSettingsStore.subscribe(applyLanguage);

export default i18n;
